/**
 * Project : workspace
 * File    : ProductDetailScreen.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.customer.product

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.parmartechnologies.business.feature.business.viewModel.BusinessViewModel
import com.parmartechnologies.commerce.feature.cart.viewModel.CartViewModel
import com.parmartechnologies.commerce.feature.inventory.product.viewModel.ProductViewModel
import com.parmartechnologies.core.navigation.NavigationParam
import com.parmartechnologies.ui.component.image.ImageView
import component.button.DefaultButton
import component.navigation.TopNavBar
import navigation.AppNavigator
import navigation.route.sale.SaleNavRoute
import presentation.screens.business.profile.self.component.ItemCard
import theme.ThemeColor

/**
 * Represents the product detail screen class.
 */

class ProductDetailScreen{
    @Composable
    fun Content() {
        val businessViewModel = BusinessViewModel()
        val selectedBusiness = businessViewModel.selectedBusiness.collectAsState()
        val viewModel = CartViewModel(business = selectedBusiness.value)
        val productViewModel = ProductViewModel(business = selectedBusiness.value)
        val products = productViewModel.allProduct.collectAsState()
        val allProducts = productViewModel.allProduct.collectAsState()
        val searchQuery = productViewModel.searchQuery.collectAsState()
        LaunchedEffect(key1 = Unit) {
            productViewModel.loadProduct()
        }
        Column(modifier = Modifier.fillMaxSize().background(ThemeColor.shared().defaultBakground)) {
            TopNavBar(title = "", NavigationParam(), onBackPress = {
                AppNavigator.shared().goBack()
            }, onClickCart = {
                AppNavigator.shared().navigate(
                    SaleNavRoute.BUSINESS_CART
                )
            })
            LazyColumn(modifier = Modifier.fillMaxSize().padding(bottom = 60.dp)) {
                item {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(230.dp)
                    ) {
                        ImageView("","")
                    }
                }
                item {

                }
                item {
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(40.dp)
                        //.background(color = Color.Green)
                        , horizontalArrangement = Arrangement.Center
                    )
                    {
                        Text("• • • • • ", fontSize = 30.sp, textAlign = TextAlign.Center)
                    }
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(55.dp)
                            .padding(4.dp),
                        verticalAlignment = Alignment.Bottom
                    )
                    {
                        Text(
                            "Toy shine Party Favor for Kids Wooden",
                            fontWeight = FontWeight.Bold,
                            fontSize = 18.sp,
                            modifier = Modifier
                                .weight(0.7f)
                        )
                        Text("₹120", fontSize = 24.sp, fontWeight = FontWeight.Bold)
                        Text(
                            "₹2̶4̶0̶", fontSize = 16.sp, color = Color.Gray, modifier = Modifier
                                .weight(0.1f)
                        )
                    }
//                    Text(
//                        " ⭐ 4.5 • 100+ Reviews",
//                        fontSize = 16.sp,
//                        color = Color.Gray,
//                        modifier = Modifier
//                            .padding(bottom = 8.dp)
//                    )
                    HorizontalDivider(
                        modifier = Modifier
                            .padding(4.dp, 8.dp)
                            .background(color = Color.Gray),
                        thickness = 2.dp
                    )
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(4.dp)
                        //.background(color = Color.Cyan)
                    ) {
                        Text(
                            "Color",
                            fontWeight = FontWeight.Bold,
                            fontSize = 18.sp,
                            modifier = Modifier
                                .weight(0.5f)
                        )
                        Text(
                            "▼",
                            fontSize = 18.sp,
                            fontWeight = FontWeight.Bold,
                            modifier = Modifier
                        )
                    }
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(80.dp)
                            .padding(4.dp)
                    )
                    {
                        Box(
                            modifier = Modifier
                                .width(80.dp)
                                .height(51.dp)
                                .padding(end = 8.dp)
                                .background(
                                    color = ThemeColor.shared().skybackground,
                                    shape = RoundedCornerShape(8.dp)
                                )
                        ) {

                        }
                        Box(
                            modifier = Modifier
                                .width(80.dp)
                                .height(51.dp)
                                .padding(end = 8.dp)
                                .background(
                                    color = ThemeColor.shared().Purple200,
                                    shape = RoundedCornerShape(8.dp)
                                )
                        ) {

                        }
                        Box(
                            modifier = Modifier
                                .width(80.dp)
                                .height(51.dp)
                                .padding(end = 8.dp)
                                .background(
                                    color = ThemeColor.shared().gray,
                                    shape = RoundedCornerShape(8.dp)
                                )
                        ) {

                        }
                        Box(
                            modifier = Modifier
                                .width(80.dp)
                                .height(51.dp)
                                .padding(end = 8.dp)
                                .background(
                                    color = ThemeColor.shared().headBackground,
                                    shape = RoundedCornerShape(8.dp)
                                )
                        ) {

                        }
                        Box(
                            modifier = Modifier
                                .width(80.dp)
                                .height(51.dp)
                                .padding(end = 8.dp)
                                .background(
                                    color = ThemeColor.shared().lightGray,
                                    shape = RoundedCornerShape(8.dp)
                                )
                        ) {

                        }
                    }
                    HorizontalDivider(
                        modifier = Modifier
                            .padding(4.dp, 8.dp)
                            .background(color = Color.Gray),
                        thickness = 2.dp
                    )
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(4.dp)
                        //.background(color = Color.Cyan)
                    ) {
                        Text(
                            "Select Size",
                            fontWeight = FontWeight.Bold,
                            fontSize = 18.sp,
                            modifier = Modifier
                                .weight(0.5f)
                        )
                        Text(
                            "▼",
                            fontSize = 18.sp,
                            fontWeight = FontWeight.Bold,
                            modifier = Modifier
                        )
                    }
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(70.dp)
                            .padding(4.dp)
                    )
                    {
                        Box(
                            modifier = Modifier
                                .width(66.dp)
                                .height(66.dp)
                                .padding(end = 8.dp)
                                .border(
                                    1.dp,
                                    Color.Gray,
                                    shape = RoundedCornerShape(8.dp),
                                )
                                .background(
                                    color = ThemeColor.shared().cardBackground,
                                    shape = RoundedCornerShape(10.dp)
                                ),

                            ) {
                            Text(
                                "S", fontSize = 20.sp, modifier = Modifier
                                    .align(Alignment.Center)
                            )
                        }
                        Box(
                            modifier = Modifier
                                .width(66.dp)
                                .height(66.dp)
                                .padding(end = 8.dp)
                                .border(BorderStroke(2.dp, color = Color.Gray))
                                .background(
                                    color = ThemeColor.shared().cardBackground,
                                    shape = RoundedCornerShape(10.dp)
                                )
                        ) {
                            Text(
                                "M", fontSize = 20.sp, modifier = Modifier
                                    .align(Alignment.Center)
                            )
                        }
                        Box(
                            modifier = Modifier
                                .width(66.dp)
                                .height(66.dp)
                                .padding(end = 8.dp)
                                .border(BorderStroke(2.dp, color = Color.Gray))
                                .background(
                                    color = ThemeColor.shared().cardBackground,
                                    shape = RoundedCornerShape(10.dp)
                                )
                        ) {
                            Text(
                                "L", fontSize = 20.sp, modifier = Modifier
                                    .align(Alignment.Center)
                            )
                        }
                        Box(
                            modifier = Modifier
                                .width(66.dp)
                                .height(66.dp)
                                .padding(end = 8.dp)
                                .border(BorderStroke(2.dp, color = Color.Gray))
                                .background(
                                    color = ThemeColor.shared().cardBackground,
                                    shape = RoundedCornerShape(10.dp)
                                )
                        ) {
                            Text(
                                "XL", fontSize = 20.sp, modifier = Modifier
                                    .align(Alignment.Center)
                            )
                        }
                        Box(
                            modifier = Modifier
                                .width(66.dp)
                                .height(66.dp)
                                .padding(end = 8.dp)
                                //.clip(RoundedCornerShape(20.dp)
                                .border(BorderStroke(2.dp, color = Color.Gray))
                                .background(color = ThemeColor.shared().cardBackground)
                        ) {
                            Text(
                                "XXL", fontSize = 20.sp, modifier = Modifier
                                    .align(Alignment.Center)
                            )
                        }
                    }
                    HorizontalDivider(
                        modifier = Modifier
                            .padding(4.dp, 8.dp)
                            .background(color = Color.Gray),
                        thickness = 2.dp
                    )
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(4.dp)
                        //.background(color = Color.Cyan)
                    ) {
                        Text(
                            "description",
                            fontWeight = FontWeight.Bold,
                            fontSize = 18.sp,
                            modifier = Modifier
                                .weight(0.5f)
                        )
                        Text(
                            "▼",
                            fontSize = 18.sp,
                            fontWeight = FontWeight.Bold,
                            modifier = Modifier
                        )
                    }
                    Text(
                        " •  This adorable cartoon car shape pen holder is made of wood.\n" +
                                " •  Size - 4.84 x 2.76 x 3.94 inch\n" +
                                " •  You can put a small picture of your child in that photo frame.\n" +
                                " •  Made of Wooden material and feels very home made product.\n" +
                                " •  Best for return gifts / favor bags for kids birthday party for all age groups",
                        fontSize = 14.sp,
                        color = Color.Gray
                    )
                    HorizontalDivider(
                        modifier = Modifier
                            .padding(4.dp, 8.dp)
                            .background(color = Color.Gray),
                        thickness = 3.dp
                    )
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(4.dp)
                        //.background(color = Color.Cyan)
                    ) {
                        Text(
                            "Reviews & Ratings",
                            fontWeight = FontWeight.Bold,
                            fontSize = 18.sp,
                            modifier = Modifier
                                .weight(0.5f)
                        )
                        Text(
                            "▼",
                            fontSize = 18.sp,
                            fontWeight = FontWeight.Bold,
                            modifier = Modifier
                        )
                    }
                }
//                item { FeedbackCard() }
//                item { FeedbackCard() }
                item {
                    Column(
                        modifier = Modifier
                            .fillMaxWidth().fillMaxHeight()
                            .padding(4.dp)
                        //.background(color = Color.Cyan)
                    ) {
                        HorizontalDivider(
                            modifier = Modifier
                                .padding(4.dp, 8.dp)
                                .background(color = Color.Gray),
                            thickness = 3.dp
                        )
                        Row {
                            Text(
                                "Similar Products",
                                fontWeight = FontWeight.Bold,
                                fontSize = 18.sp,
                                modifier = Modifier
                                    .weight(0.5f)
                            )
                            Text(
                                "▼",
                                fontSize = 18.sp,
                                fontWeight = FontWeight.Bold,
                                modifier = Modifier
                            )
                        }



                        LazyRow(modifier = Modifier.padding(start = 8.dp, end = 8.dp)) {
                            items(products.value.count()) { index ->
                                ItemCard(products.value[index], viewModel, AppNavigator.shared().getNavigationParam())
                            }
                        }
                        Box(
                            modifier = Modifier.fillMaxWidth().height(60.dp).padding(top = 8.dp)
                        ) { DefaultButton("Add to Cart", {}) }

                    }
                }
            }
        }
    }
}